import ContactsTrending from '../../trending/contact_trending';
import EntitiesTrending from '../../trending/entities_trending';
import ThemesTrending from '../../trending/themes_trending';
import '../style/trending.css';

function TendancesTab({contact,setFilter, entity, themes, root}){
  return(
    <>
      <section className="c-container_one_explore">
        <div className="c-container_contacts-entities_explore">
          <ContactsTrending contacts={contact} setFilter={setFilter} root={root}/>
          <EntitiesTrending entities={entity} setFilter={setFilter} root={root}/>
          <ThemesTrending themes={themes} setFilter={setFilter} root={root}/>
        </div>
      </section>
    </>
  )
}

export default TendancesTab
